const SHEET_ID = process.env.REACT_APP_GOOGLE_SHEET_ID;
const API_KEY = process.env.REACT_APP_GOOGLE_SHEETS_API_KEY;
const SHEET_RANGE = process.env.REACT_APP_GOOGLE_SHEET_RANGE || 'Sheet1!A2:I';
const SHEET_NAME = process.env.REACT_APP_GOOGLE_SHEET_NAME || 'Sheet1';

const isActive = (value) => {
  if (value === undefined || value === null || String(value).trim() === '') {
    return true;
  }

  const normalized = String(value).trim().toLowerCase();
  return !['n', 'no', 'false', '0', 'inactive'].includes(normalized);
};

const parseSkills = (skillsRaw) => {
  if (!skillsRaw || !String(skillsRaw).trim()) {
    return ['Required Skills:'];
  }

  const skills = String(skillsRaw)
    .split(',')
    .map((skill) => skill.trim())
    .filter(Boolean);

  return ['Required Skills:', ...skills];
};

const rowToJob = (row, index) => {
  const [
    title = '',
    experience = '',
    qualification = '',
    type = '',
    responsibilities = '',
    location = '',
    deadline = '',
    skillsRaw = '',
  ] = row;

  return {
    id: `${title}-${deadline}-${index}`,
    title: String(title).trim(),
    experience: String(experience).trim(),
    qualification: String(qualification).trim(),
    type: String(type).trim(),
    responsibilities: String(responsibilities).trim(),
    location: String(location).trim(),
    deadline: String(deadline).trim(),
    skills: parseSkills(skillsRaw),
  };
};

const parseSheetRows = (rows) =>
  rows
    .filter((row) => row.some((cell) => String(cell ?? '').trim()))
    .filter((row) => isActive(row[8]))
    .map((row, index) => rowToJob(row, index))
    .filter((job) => job.title);

const fetchViaSheetsApi = async () => {
  const url = `https://sheets.googleapis.com/v4/spreadsheets/${SHEET_ID}/values/${encodeURIComponent(
    SHEET_RANGE
  )}?key=${API_KEY}`;

  const response = await fetch(url);

  const data = await response.json();

  console.log("Google response:", data);

  if (!response.ok) {
    throw new Error(data.error?.message || "Unable to load job listings");
  }

  return parseSheetRows(data.values || []);
};

const fetchViaGviz = async () => {
  const url = `https://docs.google.com/spreadsheets/d/${SHEET_ID}/gviz/tq?tqx=out:json&sheet=${encodeURIComponent(
    SHEET_NAME
  )}`;

  const response = await fetch(url);

  if (!response.ok) {
    throw new Error('Unable to load job listings from Google Sheets.');
  }

  const text = await response.text();
  const json = JSON.parse(text.substring(47, text.length - 2));
  const rows = (json.table?.rows || []).map((row) =>
    (row.c || []).map((cell) => (cell?.v ?? '').toString())
  );

  return parseSheetRows(rows.slice(1));
};

export const fetchJobListings = async () => {
  if (!SHEET_ID) {
    throw new Error(
      'REACT_APP_GOOGLE_SHEET_ID is not configured. Add it to your .env file.'
    );
  }

  if (API_KEY) {
    return fetchViaSheetsApi();
  }

  return fetchViaGviz();
};
